import React from 'react'
import { Button } from '@workwhile/ui'
import { Pencil } from 'lucide-react'
import { useIndeedFlexCompaniesContextValue } from '../context/IndeedFlexCompaniesProvider'
import { useIndeedFlexCompaniesWorkflowsContextValue } from '../context/IndeedFlexCompaniesWorkflowsProvider'

type EditCompanyButtonProps = {
  company: ReturnType<
    typeof useIndeedFlexCompaniesContextValue
  >['state']['data']['items'][number]
}

export const EditCompanyButton = ({ company }: EditCompanyButtonProps) => {
  const { editCompanyFlow } = useIndeedFlexCompaniesWorkflowsContextValue()

  return (
    <Button
      variant="secondary"
      kind="small"
      aria-label="Edit company"
      onClick={() => editCompanyFlow.open(company)}
    >
      <Pencil size={14} />
    </Button>
  )
}
